import { NodeUi } from 'classes/NodeUi';
import { ApiService } from 'services/api.service';
import { AutoFocusDirective } from './../auto-focus.directive';
import { BaseNodeConfig, RenderNodeConfig } from 'dto/NodeConfig';
import { FlowResultDto } from 'dto/FlowResultDto';
import { FlowUi } from 'classes/FlowUi';
import { FlowService } from 'services/flow.service';

import { Component, Input, ViewChildren, AfterViewInit, AfterViewChecked, OnChanges, OnInit } from '@angular/core';
import { UiElementType } from "classes/UIElementType";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { MessageboxComponent } from "app/messagebox/messagebox.component";
import { LocaleService, TranslationService } from "angular-l10n";

@Component({
  selector: 'flow-engine',
  templateUrl: './flow-engine.component.html',
  styleUrls: ['./flow-engine.component.css','./flow-engine.android.component.css']
})
export class FlowEngineComponent implements OnInit, OnChanges {
  textaligns:any[] = ['left','right'];
  title:string = null;
  // Allow the use of this enum in the HTML switch-case
  UiElementType = UiElementType;
  // Construct RegExp using literal notation (not a quoted string) this ensures it is only compiled once.
  _translationKeyRegex = new RegExp(/\{.*?\}/, 'ug');

  //todo: Currently based on a flow UI, but should also be able to handle a FlowDto
  @Input()
  // TODO: Make this redundant, then remove it.
  // Do we need the entire FlowUi here? Maybe just the required inputs?
  flow:FlowUi;
  currentPayload:any = {};
  public nodesToRender:RenderNodeConfig[] = [];
  keyCodeListeners:RenderNodeConfig[] = [];
  loading:boolean = false;
  resources:any = [];
  private language:string;

  constructor(private api:ApiService, private flowService:FlowService, private modalService:NgbModal,public locale:LocaleService, public translation:TranslationService){}

  ngOnInit() {
    this.Reset();
    this.flowService.FlowChange.subscribe( result => {
      this.Reset();
      this.flow.flowSaved.subscribe(x=>this.Reset());
    });
  }

  ngOnChanges() {
  }

  public Reset():void{
    this.language = this.translation.getLanguage();
    //todo: filter serverside, currently all the resources are fetched from the server
    //todo: use l10n for translation
    this.api.getResources().subscribe(resources=>{
      // Update resources
      this.resources = resources.find(x=>x.Scope == 'global' && x.Language == this.language);
      this.title = '«Title not set»';
      this.flow.FlowResult = null;
      this.nodesToRender = [];
      this.currentPayload = {};
      this.UiLoop();
    });

  }

  private UiLoop():void{
    this.loading = true;
    this.api.processCycle(this.flow.dto.FlowId, this.flow.FlowResult ? this.flow.FlowResult.FlowResultId : null, this.currentPayload).subscribe(
      result => {
        this.currentPayload = {};
        this.flow.FlowResult = result;
        if(this.flow.FlowResult != null)
          // Detect a language change.
          if (this.flow.FlowResult.Payload.Language && this.flow.FlowResult.Payload.Language != this.language)
          {
            this.language = this.flow.FlowResult.Payload.Language;
            //todo: filter serverside, currently all the resources are fetched from the server
            //todo: use l10n for translation
            this.api.getResources().subscribe(resources=>{
              // Update resources
              this.resources = resources.find(x=>x.Scope == 'global' && x.Language == this.language);
              // Render Inputs only after Observable has returned and we have the new translation resources.
              this.RenderInputs();
            });
          }
          else
            // Render inputs synchronously immediately.
            this.RenderInputs();
          // CAUTION, when you've arrived here, there's no guarantee that the inputs have been rendered! Read this.loading to be sure.
        },
        error => console.error('Error: ' + error)
    );
  }

  public RenderInputs():void {
    this.keyCodeListeners = [];

    if(this.flow.FlowResult.Payload.Title){
        //todo: use l10n for translation
        this.title = this.Translate(this.flow.FlowResult.Payload.Title);
    }

    if(this.flow.FlowResult != null && this.flow.FlowResult.UiNodesToRender && this.flow.FlowResult.UiNodesToRender.length > 0) {
      for(var nodeDto of this.flow.FlowResult.UiNodesToRender) {
        
        // enhance rendernode with client-side properties based on implemented output results of parent node
        nodeDto.Clickable = nodeDto.ResultValues.some(x=>x === 'click' || x === null);

        //one time translation if available
        //todo: use l10n for translation
        if (nodeDto.Properties.Label)
          nodeDto.Properties.Label = this.Translate(nodeDto.Properties.Label);

        // pre- or already defined value
        if (this.flow.FlowResult.Payload[nodeDto.Identifier])
              // also add to the currentPayload to make sure it is passed to the engine in the next cycle
              this.currentPayload[nodeDto.Identifier] = this.flow.FlowResult.Payload[nodeDto.Identifier];
          else if (nodeDto.Properties.DefaultValue != null && nodeDto.Properties.DefaultValue !== undefined)
              this.currentPayload[nodeDto.Identifier] = nodeDto.Properties.DefaultValue;

        // Add to viewbound collection. Auto-rendered on change due to Angular binding.
        this.nodesToRender.push(nodeDto);

        //Show a modal popup because of the MessageBox UiElement is encountered. 
        switch(nodeDto.Properties.ElementType)
        {
          case UiElementType.MessageBox:
            nodeDto.Properties.Caption = this.Translate(nodeDto.Properties.Caption);
            nodeDto.Properties.Message = this.Translate(nodeDto.Properties.Message);
            const modalRef = this.modalService.open(MessageboxComponent, { backdrop: 'static', keyboard: false });
            modalRef.componentInstance.Properties = nodeDto.Properties;
            modalRef.result.then(
              result => this.Collect(nodeDto, result, false), //messagebox results never validate
              reason => this.Collect(nodeDto, reason, false)  //messagebox results never validate
            );
          break;
          case UiElementType.Label:
            nodeDto.Properties.Value = this.Translate(nodeDto.Properties.Value);
            break;
          case UiElementType.Grid:
            nodeDto.Properties.Columns.forEach(column => {
              column.Header = this.Translate(column.Header);
            });
            break;
          //A clearscreen element type clears all the previous controls from the screen.
          case UiElementType.ClearScreen:
            this.nodesToRender = [];
            break;
        }

        if(nodeDto.Properties.KeyCodes)
          this.keyCodeListeners.push(nodeDto);              
      }
    }
    this.loading = false;
  }

  public OnInputEvent(node:RenderNodeConfig, value:string):void
  {
        // 10 = InputEventTypes.DatalogicBarcodeScanner
        if (node.Properties.Action && node.Properties.Action == 10)
            this.Collect(node, value); 
  }

  //collect is used on button clicks. The Node identifier and the value are stored in the current Payload.
  public Collect(node:RenderNodeConfig,value:any, forceValidation?:boolean):void {    
    
    //validate if all the requiredInputs are provided!
    //todo: discuss if we do the validation server-side and return an error output connection point?
    if((node.Properties.Validate && node.Properties.Validate == true) || forceValidation)
      for(let node of this.nodesToRender)
          if(node.Properties.Mandatory && this.currentPayload[node.Identifier] == null)
            return; //todo: warn user not all values are provided, now it looks like the UI is stuck/frozen

    this.currentPayload[node.Identifier] = value;

    //collecting is not required because all the controls are directly bound to their currentPayload property


    //and go to the next ui cycle
    this.UiLoop();
  }

  public IsString(value:any){
    return typeof value === 'string';
  }

  //a key is pressed glabally in the engine
  public globalKeyEvent($event):void {
    
    //todo: Discuss enum, or default values? What if Android/apple? that are using other key-codes!
    var traggidCode = null; 
    if($event.keyCode == 13)
      traggidCode = '1';//ENTER;
    else if($event.keyCode == 27)
      traggidCode = '2';//ESCAPE
    else if($event.keyCode == 33) //Page-up
      traggidCode = '3';//BACK
    else if($event.keyCode == 36) //Home key
      traggidCode = '4';//HOME
    else 
      return; //no valid traggid code is pressed, do nothing

    //Loop all the nodes that are triggered by a valid traggid keycode and find the one triggered by the pressed code
    var collectAfter:RenderNodeConfig = this.keyCodeListeners.find(x=>x.Properties.KeyCodes.some(y=>y.Code == traggidCode));

    if(collectAfter){ //todo: pass value depennding on uiElementType
      $event.stopPropagation();
      this.Collect(collectAfter,'click');
    }
  }

  mouseOver(node:RenderNodeConfig)
  {
    let nodeUi = this.flow.Nodes.find(nodeUi => node.Identifier == nodeUi.dto.Identifier)
    if (nodeUi)
      nodeUi.Highlight = true;
  }

  mouseOut(node:RenderNodeConfig)
  {
    let nodeUi = this.flow.Nodes.find(nodeUi => node.Identifier == nodeUi.dto.Identifier)
    if (nodeUi)
      nodeUi.Highlight = false;
  }

  textEmpty(dto:BaseNodeConfig){
    if(this.currentPayload[dto.Identifier] === '')
      this.currentPayload[dto.Identifier] = null;
  }

  Translate(key:string)
  {
    if (!key)
      return '';
   
    if (!this.resources || !this.resources.Resources)
      return key;

    if (this.resources.Resources[key] !== undefined)
      return this.resources.Resources[key];
    
    return key.replace(this._translationKeyRegex, match => {
      let bracketless = match.substr(1,match.length-2)
      return this.resources.Resources[bracketless] !== undefined ? this.resources.Resources[bracketless] : match;
    });
    
  }
}



// WEBPACK FOOTER //
// C:/git/flowdesigner/src/app/flow-engine/flow-engine.component.ts